import { useQuery } from "@tanstack/react-query";

import { NotificationResource } from "@/types/resources";
import { api } from "@/utils/api";

interface NotificationData {
  title: string;
  description: string;
  meta: {
    testUnitId: number;
  };
}

export type Notifications = Array<NotificationResource<NotificationData>>;

const useFailedJobsNotifications = (projectId?: number|string, enabled = true) => {
  const queryKey = [
    "notifications",
    {
      notifiableType: "App\\Models\\OptimisationTest",
      notifiableId: projectId,
    },
  ];

  const { data: notifications } = useQuery<Notifications>(
    queryKey,
    () =>
      api.get<never, Notifications>("/v1/notifications", {
        params: {
          "filter[type]": "App\\Notifications\\FailedJobNotification",
          "filter[unread]": 1,
          "filter[notifiable_type]": "App\\Models\\OptimisationTest",
          ...(!!projectId && { "filter[notifiable_id]": projectId }),
        },
      }),
    {
      staleTime: 60 * 1000,
      enabled,
    }
  );

  return {
    notifications,
    queryKey,
  };
};

export default useFailedJobsNotifications;
